import { render, staticRenderFns } from "./PartnerReportDetailSendToKsrDialogKsrDetail.vue?vue&type=template&id=6d54cd3a&"
import script from "./PartnerReportDetailSendToKsrDialogKsrDetail.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportDetailSendToKsrDialogKsrDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VListItemContent,VListItemSubtitle,VRow})
